export default __webpack_public_path__ + "static/media/princ-officer.026d9015.jpg";